import { useQuery } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { FetchSavedListOutreachStatuses } from '../api';

export function useSavedListOutreachStatuses(listId: string) {
  const queryKeys = useQueryKeys();

  return useQuery({
    queryKey: queryKeys.savedCreatorsList.outreachStatuses(listId),
    queryFn: ({ signal }) => FetchSavedListOutreachStatuses(listId, signal),
    retry: false,
  });
}
